export default "__VITE_ASSET__CQ4j6_$u__"